import { render, staticRenderFns } from "./Insurs.vue?vue&type=template&id=474e54cc"
import script from "./Insurs.vue?vue&type=script&lang=js"
export * from "./Insurs.vue?vue&type=script&lang=js"
import style0 from "./Insurs.vue?vue&type=style&index=0&id=474e54cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports